<template>
    <div v-if="show">
        <v-dialog
            max-width="290"
            persistent
            v-model="show">
            <v-card>
                <v-card-title id="dialog-title"></v-card-title>
                <v-card-text id="dialog-body"></v-card-text>
                <v-card-actions style="justify-content: right;">
                    <v-btn
                        outlined
                        id="close-btn"
                        @click="show = false">
                        No
                    </v-btn>
                    <v-btn
                        id="continue-btn"
                        color="primary"
                        class="text-white"
                        @click="show = false">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
    export default {
        name: "confirm-dialog",
        data: () => ({
            show: true
        })
    }
</script>

<style scoped>
</style>